export enum CUSTOMER_SERVICE_FIELDS {
  AD_ADDED_EMPLOYEE_ONBOARDING = "ad_added_employee_onboarding",
  AD_ADDED_EMPLOYEE_SYSTEM = "ad_added_employee_system",
  AD_EDIT_EMPLOYEE_EMPLOYMENT_LINK_CLICKED = "ad_edit_employee_employment_link_clicked",
  AD_VIEW_EDIT_CONTRACT_CLICKED = "ad_view_edit_contract_clicked",
  AD_CREATED_REGISTRATION_FORM = "ad_created_registration_form",
  AD_COMPLETE_ADMISSION = "ad_complete_admission",
  FIRST_ACCESS_FLOW_MODAL = "first_access_flow_modal",
  NAME = "name",
  EMAIL = "email",
}
